import { render, staticRenderFns } from "./GlossaryView.vue?vue&type=template&id=336d60f6&scoped=true"
import script from "./GlossaryView.vue?vue&type=script&lang=js"
export * from "./GlossaryView.vue?vue&type=script&lang=js"
import style0 from "./GlossaryView.vue?vue&type=style&index=0&id=336d60f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d60f6",
  null
  
)

export default component.exports